/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import moment from "../../../../utils/customMoment";

const AdditionalItemsDetail = ({ booking }) => {
    const { additionalItemsGroups, additionalItemsQuotationPrice } = booking || {};

    if (!additionalItemsGroups?.length) return null;

    return (
        <>
            <h5 className="fw-700">Additional Items</h5>
            <div className="mb-5">
                <div className="border rounded">
                    {additionalItemsGroups.map((group, groupIndex) => (
                        <div key={groupIndex}>
                            {groupIndex > 0 && <hr className="hr-E8E8E8 m-0" />}

                            {group.heading && (
                                <div className="px-3 py-2" style={{ backgroundColor: "#F5F5F5", borderBottom: "1px solid #E8E8E8" }}>
                                    <b className="fs-14">{group.heading}</b>
                                </div>
                            )}

                            {/* Column headers */}
                            <div className="row align-items-center mx-0 px-3 py-2" style={{ backgroundColor: "#FAFAFA", borderBottom: "1px solid #E8E8E8" }}>
                                <div className="col-2">
                                    <p className="m-0 fw-700 text-grey-200 fs-12">Service Date</p>
                                </div>
                                <div className="col">
                                    <p className="m-0 fw-700 text-grey-200 fs-12">Description</p>
                                </div>
                                <div className="col-2">
                                    <p className="m-0 fw-700 text-grey-200 fs-12">Unit Price</p>
                                </div>
                                <div className="col-1">
                                    <p className="m-0 fw-700 text-grey-200 fs-12">Qty</p>
                                </div>
                                <div className="col-2">
                                    <p className="m-0 fw-700 text-grey-200 fs-12">Amount</p>
                                </div>
                            </div>

                            {/* Item rows */}
                            {(group.items || []).map((item, itemIndex) => (
                                <div
                                    key={itemIndex}
                                    className="row align-items-center mx-0 px-3 py-2"
                                    style={{ borderBottom: itemIndex < group.items.length - 1 ? "1px solid #F0F0F0" : "none" }}
                                >
                                    <div className="col-2">
                                        <b className="fs-14">
                                            {item.serviceDate ? moment(item.serviceDate).locale("en").format("MMM D, YYYY") : "-"}
                                        </b>
                                    </div>
                                    <div className="col">
                                        <b className="fs-14">{item.name || "-"}</b>
                                    </div>
                                    <div className="col-2">
                                        <b className="fs-14">{Number(item.price || 0).toLocaleString()} JPY</b>
                                    </div>
                                    <div className="col-1">
                                        <b className="fs-14">{item.qty ?? "-"}</b>
                                    </div>
                                    <div className="col-2">
                                        <b className="fs-14">{Number(item.totalPrice || 0).toLocaleString()} JPY</b>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}

                    <hr className="hr-E8E8E8 m-0" />
                    <div className="row align-items-start gap-5 p-3">
                        <div className="col-auto">
                            <p className="m-0 fw-700 text-grey-200 fs-12">Total Additional Items</p>
                            <b className="fs-14">{Number(additionalItemsQuotationPrice || 0).toLocaleString()} JPY</b>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdditionalItemsDetail;
